import { registerQuery } from '@adornis/baseql/metadata/register.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { getIntercomConversationById, IntercomEntity } from '../entities/intercom.js';

export const getIntercomEntityById = registerQuery({
  operationName: 'getIntercomEntityById',
  resolve: (conversationId: string) => async (gqlFields: BaseQLSelectionSet<IntercomEntity>) => {
    const intercomEntity = await getIntercomConversationById(conversationId);
    return intercomEntity;
  },
  params: [{ name: 'conversationId', type: () => String }],
  type: () => IntercomEntity,
});
